import { createAsyncThunk, createSlice } from "@reduxjs/toolkit"
import axios from "../../../config/authAxios"



const initialState = { status: null, loading: false, data: [], error: "", message: "" }


export const linkQuestionToSurveyAction = createAsyncThunk(
    'link-qns',
    async (data = null, { rejectWithValue }) => {
        try {
            const res = await axios.patch(`/support-server/api/link-questions-survey`, { ...data })
            return res?.data
        } catch (error) {
            return rejectWithValue(error.response.data)
        }
    }
)


export const linkQuestionToSurveySlice  = createSlice({
    name: 'link-qns',
    initialState,
    reducers: {},
    extraReducers:
        (builder) => {
            builder.addCase(linkQuestionToSurveyAction.pending, (state) => {
                state.loading = true
            })
            builder.addCase(linkQuestionToSurveyAction.fulfilled, (state, action) => {
                state.loading = false
                state.data = action?.payload?.data
                state.status = action?.payload?.status
                state.message = action?.payload?.message
            })
            builder.addCase(linkQuestionToSurveyAction.rejected, (state, action) => {
                state.loading = false
                state.error = action?.payload?.error
                state.status = action?.payload?.status
                state.message = action?.payload?.message
            })
        },

})



export const linkQuestionToSurveyReducer = linkQuestionToSurveySlice.reducer    